import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Box, 
  useTheme,
  IconButton,
  Container,
  useMediaQuery
} from '@mui/material';
import ThemeToggle from './ThemeToggle';
import { Menu as MenuIcon } from '@mui/icons-material';

const Header = ({ onMenuToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{
        background: theme.palette.mode === 'light' 
          ? theme.palette.background.default
          : theme.palette.background.default,
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid',
        borderColor: theme.palette.mode === 'light' 
          ? 'rgba(255, 255, 255, 0.2)' 
          : 'rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {onMenuToggle && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={onMenuToggle}
              sx={{ mr: 2, display: { md: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          )}
          
          <Box sx={{ flexGrow: 1 }}></Box>
          
          <Box sx={{ flexGrow: 1 }} />
          
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ThemeToggle />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
